// src/utils/pageLifecycle.js
import Vue from 'vue';

// 创建事件总线
const eventBus = new Vue();

let isVisible = true;
let lastFocusTime = 0;
const DEBOUNCE_TIME = 300;

function handleVisibilityChange() {
  isVisible = document.visibilityState === 'visible';
  if (isVisible) {
    eventBus.$emit('page-resume');
  }
}

// 初始化监听
export function initPageLifecycle() {
  document.addEventListener('visibilitychange', handleVisibilityChange);
}

export const onPageResume = callback => {
  eventBus.$on('page-resume', callback);
  return () => eventBus.$off('page-resume', callback);
};

export const offPageResume = callback => {
  eventBus.$off('page-resume', callback);
};
